export default __webpack_public_path__ + "static/media/189.509d27ff.png";